define([
    'vue',
    'web/i18n/index',
    'WebCommon/mixin/page',
    'index2021-job/component/main',
    'css!vendor/font-awesome/css/font-awesome.min.css',
    'css!WebCommon/css/ub-page-reset.css',
    'css!WebCommon/css/ub-page-grid.css',
    'css!index2021-job/component/main.css'

], function(
    Vue,
    i18n,
    PageMixin,

    MainPage
){

    var app = new Vue({
        mixins: [PageMixin],
        components: {
            MainPage: MainPage
        },
        i18n: i18n
    });
    app.$mount('#app');


});


//////////////////
// WEBPACK FOOTER
// ./index2021-job/index2021-job.js
// module id = 278
// module chunks = 7